import React from "react";
import { observer } from "mobx-react";
import { DocumentGenerationParamsViewStore } from "../../store";
import { DocumentGenerationParamsViewForm } from "./DocumentGenerationParamsViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type DocumentGenerationParamsViewProps = {
  documentGenerationParamsViewStore: DocumentGenerationParamsViewStore;
};

export const DocumentGenerationParamsView: React.FC<DocumentGenerationParamsViewProps> =
  observer(({ documentGenerationParamsViewStore }) => {
    return (
      <div>
        <DocumentGenerationParamsViewForm
          contractEffectiveDate={
            documentGenerationParamsViewStore.contractEffectiveDateValue
          }
          contractEndDate={
            documentGenerationParamsViewStore.contractEndDateValue
          }
          onPrint={(handlePrint: () => void) =>
            documentGenerationParamsViewStore.printDocumentGenerationParams(
              handlePrint
            )
          }
          onCancel={() =>
            documentGenerationParamsViewStore.cancelDocumentGenerationParams()
          }
          onEdit={
            documentGenerationParamsViewStore.isEditEnabled
              ? () =>
                  documentGenerationParamsViewStore.editDocumentGenerationParams()
              : undefined
          }
        />
        <ErrorDialog
          open={documentGenerationParamsViewStore.errorDialogOpened}
          title={documentGenerationParamsViewStore.errorTitle}
          description={documentGenerationParamsViewStore.errorDescription}
          onClose={() => documentGenerationParamsViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
